
import React, { useState, useEffect } from "react";
import { FaHeart, FaComment, FaBoxOpen } from "react-icons/fa";
import {
  FaCoins,
  FaBitcoin,
  FaDollarSign,
  FaTrophy,
  FaGem,
  FaRocket,
  FaCrown,
  FaStar,
  FaBolt,
  FaChartLine,
} from "react-icons/fa6";
import { useNavigate } from "react-router-dom";
import ProfileService from "../../../services/Profile";

const packageIcons = {
  coins: FaCoins,
  bitcoin: FaBitcoin,
  dollar: FaDollarSign,
  crown: FaCrown,
  rocket: FaRocket,
  trophy: FaTrophy,
  gem: FaGem,
  star: FaStar,
  bolt: FaBolt,
  chart: FaChartLine,
};

export default function NewPackages() {
  const navigate = useNavigate();

  const [newPackages, setNewPackages] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const getAllPackages = async () => {
      try {
        const params = { isSpecial: true };
        const res = await ProfileService.getAllPackages(params);

        setNewPackages(res?.data?.data || []);
      } catch (err) {
        setNewPackages([]);
      } finally {
        setLoading(false);
      }
    };

    getAllPackages();
  }, []);

  const formatPrice = (price) => {
    if (price === 0) return "Free";
    return `USDT ${price?.toLocaleString("en-US")}`;
  };

  return (
    <section id="new-packages" className="py-6">
      <div className="px-4 mb-4">
        <div className="flex items-center justify-between">
          <h2 className="text-xl font-bold">Special Packages</h2>
          <button
            onClick={() => navigate("/signal/packages")}
            className="text-sm text-primary font-medium"
          >
            View All
          </button>
        </div>

        <p className="text-sm text-gray-500 mt-1">
          Best trading packages
        </p>
      </div>

      {loading ? null : newPackages.length === 0 ? (
        <div className="mx-4 rounded-2xl border border-dashed border-gray-200 bg-gray-50 py-10 px-4 text-center">
          <FaBoxOpen className="mx-auto mb-3 text-3xl text-gray-300" />
          <p className="text-sm font-medium text-gray-600">
            No packages found
          </p>
          <p className="mt-1 text-xs text-gray-400">
            There are no special packages available right now.
          </p>
        </div>
      ) : (
        <div className="flex gap-4 overflow-x-auto px-4 pb-2">
          {newPackages.map((pkg) => {
            const PackageIcon = packageIcons[pkg?.packageIcon];

            return (
              <div
                key={pkg?._id}
                onClick={() =>
                  navigate(`/signal/package/${pkg?._id}`)
                }
                className="flex-shrink-0 w-64 border border-gray-200 rounded-2xl shadow-md p-4 flex flex-col justify-between cursor-pointer hover:shadow-lg transition-shadow duration-300"
              >
                <div>
                  <div className="flex justify-between items-start mb-2">
                    {PackageIcon && (
                      <PackageIcon className="text-2xl text-gray-700" />
                    )}

                    {pkg?.packageBadge && (
                      <span className="bg-gray-200 text-gray-700 text-xs px-2 py-1 rounded-full">
                        {pkg.packageBadge}
                      </span>
                    )}
                  </div>

                  <h3 className="text-xl font-bold text-gray-900">
                    {pkg?.name}
                  </h3>

                  <p className="text-gray-600 text-sm">
                    {pkg?.description}
                  </p>

                  <div className="flex items-center space-x-3 mt-2">
                    <div className="flex items-center space-x-1">
                      <FaHeart className="text-gray-400 text-sm" />
                      <span className="text-gray-600 text-sm">
                        {pkg?.likes ?? pkg?.likeCount ?? 0}
                      </span>
                    </div>

                    <div className="flex items-center space-x-1">
                      <FaComment className="text-gray-400 text-sm" />
                      <span className="text-gray-600 text-sm">
                        {pkg?.commentCount ?? 0}
                      </span>
                    </div>
                  </div>
                </div>

                <div className="space-y-2 text-gray-700 mt-4">
                  <div className="flex justify-between items-center text-sm">
                    <span className="text-gray-600">
                      Duration
                    </span>

                    <span className="font-semibold">
                      {pkg?.duration?.days
                        ? `${pkg.duration.days} Days`
                        : "Unlimited"}
                    </span>
                  </div>

                  {pkg?.packageFeatures?.length > 0 && (
                    <div className="space-y-1">
                      {pkg.packageFeatures.map((feature, index) => (
                        <p key={index} className="text-sm text-gray-600">
                          {typeof feature === "string"
                            ? feature
                            : feature?.name}
                        </p>
                      ))}
                    </div>
                  )}
                </div>

                <div className="border-t border-gray-300 pt-3 mt-3">
                  <div className="flex items-center justify-between">
                    <div>
                      <p className="font-medium text-sm text-gray-900">
                        {[
                          pkg?.admin?.firstName,
                          pkg?.admin?.lastName,
                        ]
                          .filter(Boolean)
                          .join(" ") || pkg?.admin?.userName}
                      </p>

                     
                    </div>

                    <span className="text-gray-900 font-bold text-lg">
                      {formatPrice(pkg?.price)}
                    </span>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </section>
  );
}
